import { Editor } from '@tiptap/react'
import React from 'react'
import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'
import { TiptapEditorUpdatePayload } from '..'
import { headingFontSize, mobileHeadingFontSize } from '../constants'
import { useGroupedToolbarCommands } from '../hooks/use-grouped-toolbar-command'
import { ToolbarButtonUi } from '../ui/toolbar-button-ui'

interface HeadlineControlsProps {
  editor: Editor
  update: (payload: Partial<TiptapEditorUpdatePayload>) => void
}

export const HeadlineControls = ({ editor, update }: HeadlineControlsProps) => {
  const { headingControls } = useGroupedToolbarCommands(editor)

  const handleToggle = (type: HeadingTypeEnum, command: () => void) => {
    update({
      ...headingFontSize[type],
      ...mobileHeadingFontSize[type],
    })
    command()
  }

  return (
    <>
      {headingControls.map(({ className, type, command, level }) => (
        <ToolbarButtonUi
          key={type}
          onClick={() => handleToggle(type, command)}
          active={editor.isActive('heading', { level })}
        >
          <i className={className} />
        </ToolbarButtonUi>
      ))}
    </>
  )
}
